import { useMemo } from 'react';

import { seasonService } from '../../../../services';
import { createApiSlice } from '../../utils/createApiSlice';

const addSeasonFieldDeviceSlice = createApiSlice({
  reducerPath: ['devices', 'seasonFieldDevices', 'addSeasonFieldDevice'],
  apiFunction: seasonService.addFieldDeviceV2
});

const { actions, useApiSelectors } = addSeasonFieldDeviceSlice;

export const addSeasonFieldDeviceActions = actions;

export const useAddSeasonFieldDeviceSelectors = () => {
  const { inProgress, success, errorMessage, response, updatedAt } =
    useApiSelectors();

  return useMemo(
    () => ({ inProgress, success, errorMessage, response, updatedAt }),
    [errorMessage, inProgress, response, success, updatedAt]
  );
};

export default addSeasonFieldDeviceSlice;
